import { useState } from "react";
import { sanitizeLinkedinProfilePictureUrl } from "../../utils/linkedinProfilePicture";

export type LeadProspectAvatarProps = {
  picture?: string | null;
  initials: string;
  initialsClassName?: string;
  className?: string;
};

/**
 * Prospect row avatar: LinkedIn CDN URL when load succeeds, initials on missing/403/expired URL.
 */
export default function LeadProspectAvatar({
  picture,
  initials,
  initialsClassName = "bg-user-avatar text-user-avatar-fg",
  className = "h-[21px] w-[21px]",
}: LeadProspectAvatarProps) {
  const [failed, setFailed] = useState(false);
  const src = sanitizeLinkedinProfilePictureUrl(picture);

  if (!src || failed) {
    return (
      <span
        className={`grid shrink-0 place-items-center rounded-full text-[8px] font-semibold ${className} ${initialsClassName}`}
        aria-hidden
      >
        {initials}
      </span>
    );
  }

  return (
    <img
      src={src}
      alt=""
      referrerPolicy="no-referrer"
      className={`shrink-0 rounded-full object-cover bg-[#eef1f4] ${className}`}
      onError={() => setFailed(true)}
    />
  );
}
